import { render, staticRenderFns } from "./VideoListN.vue?vue&type=template&id=109fd510&scoped=true"
import script from "./VideoListN.vue?vue&type=script&lang=js"
export * from "./VideoListN.vue?vue&type=script&lang=js"
import style0 from "./VideoListN.vue?vue&type=style&index=0&id=109fd510&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109fd510",
  null
  
)

export default component.exports